export function getFullPath() {
  return window.location.pathname + window.location.search + window.location.hash
}
